import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function ExtensionLogin() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    const url = new URL(window.location.href);
    const extensionId = url.searchParams.get('extension_id');

    if (!extensionId) {
      console.error('No extension_id provided');
      return;
    }

    // If user is logged in, immediately redirect the token back to extension
    if (user) {
      const session = window.localStorage.getItem('sb-swirl-auth-token');

      if (session) {
        try {
          const parsed = JSON.parse(session);
          const accessToken = parsed?.access_token;

          if (accessToken) {
            window.location.href =
              `chrome-extension://${extensionId}/auth-bridge.html?token=${accessToken}`;
            return;
          }
        } catch (err) {
          console.error('Failed to parse session', err);
        }
      }

      return;
    }

    // If NOT logged in, show the login screen
    // and let the AuthPage handle actual login
  }, [user, loading]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-800">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-4">
            <svg className="w-8 h-8 text-purple-600 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Connecting to Swirl
          </h1>
          <p className="text-gray-600">
            {loading ? 'Checking session...' : 'Finishing login...'}
          </p>
        </div>
      </div>
    </div>
  );
}



